import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
 
const PrivateRoute = ({ children }) => {
    const { state } = useAuth();
 
    // Show nothing while checking auth state
    if (state.isAuthenticated === null) {
        return null;
    }
 
    // Redirect to login if not authenticated
    return state.isAuthenticated ? children : <Navigate to="/" replace />;
};
 
export default PrivateRoute;